export default "__VITE_PUBLIC_ASSET__9d371055__"